export default __webpack_public_path__ + "static/media/reset-red.195ed1bf.png";